import { useState } from "react";
import toast from "react-hot-toast";

import { usePatientNotes } from "features/consultations/hooks/usePatientNotes";

import { formatNoteContent } from "../utils/formatContent";

export const useInsertNote = ({ patientId, onInsert }) => {
  const [showModal, setShowModal] = useState(false);
  const [search, setSearch] = useState("");

  const { data: notes, isLoading } = usePatientNotes(patientId);

  const filtered =
    notes?.filter((note) =>
      (note.note || "").toLowerCase().includes(search.toLowerCase())
    ) ?? [];

  const handleInsert = (note) => {
    onInsert(formatNoteContent(note));
    setShowModal(false);
    setSearch("");
    toast.success("Note added to email");
  };

  return {
    showModal,
    openModal: () => setShowModal(true),
    closeModal: () => { setShowModal(false); setSearch(""); },
    search,
    setSearch,
    filtered,
    isLoading,
    handleInsert,
  };
};
